export default __webpack_public_path__ + "static/media/Kosalan Grace.bb010afa.jpg";